import { useMemo } from 'react';

import { SlideshowSlide } from './slideshow.constants';
import { sortSlides } from './slideshow.utils';
import { usePagesPreview } from '../shared/pages-preview.hooks';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';

export const useCommonSlideshow = ({
  slideshowImages,
  selectedIndex,
  captureKeypress,
}: {
  slideshowImages: SlideshowSlide[] | null;
  selectedIndex: number;
  captureKeypress: boolean;
}) => {
  const slides = useMemo(
    () => sortSlides(slideshowImages || []),
    [slideshowImages]
  );

  const { index, setIndex, isLoading, getPrev, getNext, setIsLoading } =
    usePagesPreview({
      items: slides,
      selected: slides[selectedIndex],
      captureKeypressNavigation: captureKeypress,
    });
  const slide = slides[index];

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: slide?.properties.imageUrls?.[0].urls[0].url || '',
    onComplete: () => setIsLoading(false),
  });

  return {
    slides,
    imageDimensions,
    index,
    setIndex,
    isLoading,
    getPrev,
    getNext,
    setIsLoading,
    setContainerElement,
  };
};
